export function financeUiEnabled(flag: boolean | undefined): boolean {
  return flag === true
}

export function directorUiEnabled(flag: boolean | undefined): boolean {
  return flag === true
}

type DeductionRequest = {
  director_enabled?: boolean
  hr_module_enabled?: boolean
  show_requester_finance_hint?: boolean
  can_change_requester_finance?: boolean
  requester_deduction?: 'ipb' | 'salary' | null
  finance_lock_reason?: string | null
  requester_school_default?: 'ipb' | 'salary' | null
}

export function showRequesterDeductionBand(
  request: DeductionRequest | null | undefined,
  deductionPersonal?: 'ipb' | 'salary' | null,
): boolean {
  if (!request) return false
  if (!directorUiEnabled(request.director_enabled)) return false
  if (!financeUiEnabled(request.hr_module_enabled)) return false
  if (!request.requester_school_default) return false
  return Boolean(
    request.show_requester_finance_hint
    || request.can_change_requester_finance
    || deductionPersonal
    || request.requester_deduction
    || request.finance_lock_reason === 'binding'
    || request.finance_lock_reason === 'settled',
  )
}

type PayoutRequest = {
  hr_module_enabled?: boolean
  finance_eligible?: boolean
  finance_lock_reason?: string | null
  finance_school_default?: string | null
}

export function showSubstitutePayBand(
  directorOn: boolean,
  request: PayoutRequest | null | undefined,
): boolean {
  if (!directorOn || !request) return false
  return financeUiEnabled(request.hr_module_enabled)
    && request.finance_eligible === true
    && request.finance_lock_reason !== 'not_in_play'
    && request.finance_lock_reason !== 'decider_hr'
    && Boolean(request.finance_school_default)
}
